package kz.dentalcrm.app.data

import kz.dentalcrm.app.core.storage.Storage
import kz.dentalcrm.app.data.network.AuthApi
import kz.dentalcrm.app.domain.AuthRepository

class AuthRepositoryImpl(
    private val authApi: AuthApi,
    private val storage: Storage,
) : AuthRepository {

    override suspend fun isLoggedIn(): Boolean {
        return storage.getAccessToken().isNotEmpty()
    }

    override suspend fun login(email: String, password: String) =
        authApi.login(email, password)

    override suspend fun saveCredo(email: String, password: String, token: String) {
        storage.saveCredo(email, password, token)
    }

    override suspend fun clearAllData(): Boolean {
        storage.clearData()
        return true
    }
}